import React from 'react'

import { Tag } from '@insquad/tools'
import Link from 'next/link'
import { useRouter } from 'next/router'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { CURRENT_DATA_SKILLS } from 'src/data/skillsData/skills'
import { UnknownObject } from 'src/utils/reactTypes'

import s from './ResumesTags.module.scss'

export const ResumesTags: React.FC<UnknownObject> = () => {
  const router = useRouter()
  const { slug } = router.query

  return (
    <div className={s.ResumesTags}>
      <Typography
        variant={EnumTypographyVariants.H7}
        text="Browse other developers"
        className={s.ResumesTags__title}
      />

      <div className={s.ResumesTags__tags}>
        {CURRENT_DATA_SKILLS.filter(({ url }) => url !== slug)
          .slice(0, 8)
          .map(({ url, publicName }, i) => (
            <Link key={i} href={url}>
              <Tag as="a" href={url} className={s.ResumesTags__tag}>
                {publicName}
              </Tag>
            </Link>
          ))}
      </div>
    </div>
  )
}
